import(/* webpackMode: "eager" */ "/vercel/path0/app/vs/page.jsx");
